import CollapseableCard from "../../../../CommonElements/Collapse/CollapseableCard";
import UpdateProfil from "./UpdateProfil";
import AjukanCuti from "./AjukanCuti";
import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";

const QuickOption = (props) => {
  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Pilihan Cepat"}>
          <Row className="options-main text-center justify-content-center">
            <AjukanCuti />
            <UpdateProfil dataStaf={props.dataStaf}/>
          </Row>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};
export default QuickOption;
